var map = {
	"./1.webp": 751,
	"./10.webp": 752,
	"./11.webp": 753,
	"./12.webp": 754,
	"./2.webp": 755,
	"./3.webp": 756,
	"./4.webp": 757,
	"./5.webp": 758,
	"./6.webp": 759,
	"./7.webp": 760,
	"./8.webp": 761,
	"./9.webp": 762,
	"./GG-Icon": 475,
	"./GG-Icon.png": 475,
	"./background": 763,
	"./background.png": 763,
	"./burger_menu": 476,
	"./burger_menu.png": 476,
	"./club.webp": 764,
	"./error-icon": 325,
	"./error-icon.svg": 325,
	"./log_out.webp": 765,
	"./player_profile.webp": 766,
	"./settings.webp": 767
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1349;